import React from "react";
import tokenomics from "./../assets/png/chart-center.png";
import DonateChart from "./DonateChart";
function Tokenomics() {
  return (
    <>
      <div
        id="Tokenomics"
        className="text-center w-full my-12 xl:my-20 xl:pt-10 2xl:pt-16 tokenomics-bg"
      >
        <h2
          className="text-black text-3xl sm:text-5xl  xl:text-[70px] 2xl:text-[100px] text-aircruiser xl:tracking-[-2px] text-shadow-2 uppercase text-center  "
          data-aos="fade-down"
          data-aos-duration="1500"
        >
          Tokenomics
        </h2>
        <div className="">
          <div className="relative  flex flex-col justify-center items-center  max-w-[300px] sm:max-w-fit mx-auto sm:py-28 py-1 ">
            <DonateChart />
            <div className="absolute  ">
              <img
                src={tokenomics}
                alt="img"
                className="w-full bg-[#0279E1] object-cover max-w-[150px] sm:max-w-[200px] lg:max-w-[342px] rounded-full border-[10px] border-white "
              />
            </div>
          </div>{" "}
          <div className="flex flex-wrap justify-center  gap-3 sm:hidden px-5  ">
            <div className="text-start">
              <p className="text-aircruiser text-black text-2xl md:text-3xl lg:text-[40px]">
                80%
              </p>
              <p className="text-black text-base md:text-lg">
                liquidity fo Raydium
              </p>
            </div>{" "}
            <div className="text-start">
              <p className="text-aircruiser text-black text-2xl md:text-3xl lg:text-[40px]">
                10%
              </p>
              <p className="text-black text-base md:text-lg">
                Community presale
              </p>
            </div>{" "}
            <div className="text-start">
              <p className="text-aircruiser text-black text-2xl md:text-3xl lg:text-[40px]">
                5%
              </p>
              <p className="text-black text-base md:text-lg">Airdrop</p>
            </div>{" "}
            <div className=" text-start">
              <p className="text-aircruiser text-black text-2xl md:text-3xl lg:text-[40px]">
                5%
              </p>
              <p className="text-black text-base md:text-lg">Team</p>
            </div>
          </div>
          <div
            className="text-center  pb-10 mt-6  sm:pb-28"
            data-aos="fade-down"
            data-aos-duration="1500"
          >
            <p className="text-aircruiser text-black text-2xl md:text-3xl lg:text-[40px]">
              555,555,555
            </p>
            <p className="text-black text-base md:text-lg">TOKEN SUPPLY</p>
          </div>{" "}
        </div>
      </div>
    </>
  );
}

export default Tokenomics;
